import Phase from "@klintm/phase";
import { useStore as _useStore } from "@klintm/phase-react";

import Storage from "src/storage";
import { genUID, parseQs } from "src/utils";
import { dataset } from "src/core/globals";

const cached = Storage.get("cached-store") || {};
const params = parseQs(window.location.search);

const units = navigator.language.includes("US") ? "imperial" : "metric";

const IFRAME_CLICK_HANDLERS = {};
const UNLOAD_HANDLERS = {};

setInterval(function () {
  var elem = document.activeElement;
  if (elem && elem.tagName === 'IFRAME') {
    Object.values(IFRAME_CLICK_HANDLERS).forEach(([checkCb, cb]) => {
      if (checkCb(elem)) {
        cb(elem);
      }
    });
    window.focus();
  }
}, 25);

const addIframeClickEventListener = (eventId, checkCb, cb) => {
  IFRAME_CLICK_HANDLERS[eventId] = [checkCb, cb];
};

const removeIframeClickEventListener = (eventId) => {
  delete IFRAME_CLICK_HANDLERS[eventId];
};

const addUnloadHandler = (handlerId, handler, source) => {
  UNLOAD_HANDLERS[handlerId] = { handler, source };
};


const removeUnloadHandler = (handlerId) => {
  delete UNLOAD_HANDLERS[handlerId];
};


const runUnloadHandlers = () => {
  Object.values(UNLOAD_HANDLERS).forEach(({ handler, source: handlerSource }) => {
    if (handlerSource === IFRAME_CLICKED.source) {
      handler();
    }
  });
};

const IFRAME_CLICKED = { clicked: false, source: null };

const setIframeClicked = (value, source = null) => {
  IFRAME_CLICKED.clicked = value;
  IFRAME_CLICKED.source = source;
};

const resetIframeClicked = () => {
  setTimeout(() => {
    IFRAME_CLICKED.clicked = false;
    IFRAME_CLICKED.source = null;
  }, 200);
};

const getIframeClicked = () => IFRAME_CLICKED.clicked;
const getIframeClickedSource = () => IFRAME_CLICKED.source;

window.addEventListener('beforeunload', () => {
  // Introduce a delay to ensure click event is processed
  setTimeout(() => {
    runUnloadHandlers();
    resetIframeClicked();
  }, 100);
});

const store = Phase({
  ...cached,
  config: {
    units,
    location: {},
    ...(cached.config || {}),
    ...dataset,
    ...params,
    pageViewId: genUID()
  },
  state: {
    ...(cached.state || {}), cdnImage: null
  },
  iframeClickTrackers: {
    // Please do not mutate activeEvents directly but instead use the functions, it is exported here just in case you need it
    activeEvents: IFRAME_CLICK_HANDLERS,
    addIframeClickEventListener,
    removeIframeClickEventListener,
    setIframeClicked,
    resetIframeClicked,
    getIframeClicked,
    getIframeClickedSource,
  },
  unloadHandlers: {
    addUnloadHandler,
    removeUnloadHandler
  },
  children: [],
  searchBarConfig: {}
});
store.setCdnImage = (cdnImage) => {
  store.set("state", { ...store.state, cdnImage });
  Storage.set("cached-store", { ...store.state, cdnImage });
};
export default store;

export const useStore = watched => _useStore(store, watched);

// Expose hook in dev/staging
window.store = GLOBALS.ENV !== "production" && store;
